<!-- Added by amisha on 24/12/2025 -->
@if (!templateForPermitForm) {
<div [ngClass]="{'form-group': showLabel}">
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>

  <input
    type="text"
    readonly
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="entity.value"
  />
</div>
<!-- Added by amisha on 24/12/2025 -->
} @else {
<div class="permit-system-entity">
  <!-- <wm-common-text
    class="permit-label"
    [data]="{
      text: entity.label,
      weight: 'medium'
    }"
  ></wm-common-text> -->
<!-- Updated by Vipul on 29-09-2026 -->
  <wm-common-text
    class="permit-label"
    [data]="{
      text: entity.label,
    }"
  ></wm-common-text>

  <wm-common-text
    [data]="{
      text: entity.value
    }"
  ></wm-common-text>
<!-- Updated by Vipul on 29-09-2026 -->
</div>
}
<!-- End by amisha on 24/12/2025 -->
